import { slice, fetchRules } from './rule.slice';
export { fetchRules };
export default slice.reducer;
